module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"section":{"prefix":"Other ","title":"{prefix}Internships"}}}')
  delete Component.options._Ctor
}
